import React from "react";

import ModulePanel from "../../ModulePanel";

//import surveyQuestions from "../../../screens/Survey/Questions/questions.json";

const QuestionsCount = ({ survey_questions, completes = 0, total = 0 }) => {

    return (
        <ModulePanel title={["Cantidad de feedback recibido"]}>
            <div className="row text-center">
                
                <div className="col-md-4">
                    <h1>{completes}</h1>
                    <small>COMPLETADAS</small>
                </div>

                <div className="col-md-4">
                    <h1>{total - completes}</h1>
                    <small>INCOMPLETAS</small>
                </div>

                <div className="col-md-4">
                    <h1>{total}</h1>
                    <small>TOTAL</small>
                </div> 
            </div>
        </ModulePanel>
    )
}

export default QuestionsCount;